module.exports = "<app-header ></app-header>\n<app-side-bar [module]=\"module\"></app-side-bar>\n<app-modal></app-modal>\n<div id=\"corp\" [ngClass]=\"Statique.hideSideBar ? '' : 'app-wrapper'\">\n    <app-corp></app-corp>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main